module.exports = __webpack_public_path__ + "assets/co2-save.c0bf02b2.svg";